import { render, staticRenderFns } from "./_RecognitionDialog.vue?vue&type=template&id=d0c3642a&"
import script from "./_RecognitionDialog.vue?vue&type=script&lang=js&"
export * from "./_RecognitionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports